import React, { PropsWithChildren } from "react";
import { Box } from "./AHTheme/Box";
import { useCircleSize } from "./LayoutProvider";
import { AHText, AHTextFonts } from "./Text";

import Svg, { Path } from "react-native-svg";

export const TodoPrioIcon = React.memo(TodoPrioIconC);
function TodoPrioIconC(props: {
  priority: "LOW" | "DEFAULT" | "HIGH" | "URGENT";
  hideDefault?: boolean;
  isInactive?: boolean;
  size?: "xsmall" | "small";
}) {
  const size = props.size ?? "small";
  switch (props.priority) {
    case "LOW":
      return (
        <PrioIconWrapper isInactive={props.isInactive} size={size}>
          <Path
            d="M11 6H11.5C12.0304 6 12.5391 6.21071 12.9142 6.58579C13.2893 6.96086 13.5 7.46957 13.5 8C13.5 8.53043 13.2893 9.03914 12.9142 9.41421C12.5391 9.78929 12.0304 10 11.5 10H11"
            stroke="#AFAFAF"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <Path
            d="M3 6H11V10.5C11 11.0304 10.7893 11.5391 10.4142 11.9142C10.0391 12.2893 9.53043 12.5 9 12.5H5C4.46957 12.5 3.96086 12.2893 3.58579 11.9142C3.21071 11.5391 3 11.0304 3 10.5V6Z"
            stroke="#AFAFAF"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <Path
            d="M5 2.5V4"
            stroke="#AFAFAF"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <Path
            d="M7 2.5V4"
            stroke="#AFAFAF"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <Path
            d="M9 2.5V4"
            stroke="#AFAFAF"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </PrioIconWrapper>
      );
    case "DEFAULT":
      if (props.hideDefault) {
        return null;
      }
      return (
        <PrioIconWrapper isInactive={props.isInactive} size={size}>
          <AHText
            textAlign="center"
            color="text-secondary"
            font={AHTextFonts.BOLDER}
            size={12}
          >
            -
          </AHText>
        </PrioIconWrapper>
      );
    case "HIGH":
      return (
        <PrioIconWrapper isInactive={props.isInactive} size={size}>
          <Path
            d="M4 0.5H12C13.933 0.5 15.5 2.067 15.5 4V12C15.5 13.933 13.933 15.5 12 15.5H4C2.067 15.5 0.5 13.933 0.5 12V4C0.5 2.067 2.067 0.5 4 0.5Z"
            stroke="#FF435A"
          />
          <Path
            d="M8.87602 3.698L8.68402 9.494H7.26802L7.06402 3.698H8.87602ZM8.01202 12.302C7.70802 12.302 7.45602 12.21 7.25602 12.026C7.06402 11.834 6.96802 11.598 6.96802 11.318C6.96802 11.038 7.06402 10.806 7.25602 10.622C7.45602 10.43 7.70802 10.334 8.01202 10.334C8.30802 10.334 8.55202 10.43 8.74402 10.622C8.93602 10.806 9.03202 11.038 9.03202 11.318C9.03202 11.598 8.93602 11.834 8.74402 12.026C8.55202 12.21 8.30802 12.302 8.01202 12.302Z"
            fill="#FF435A"
          />
        </PrioIconWrapper>
      );

    case "URGENT":
      return (
        <PrioIconWrapper isInactive={props.isInactive} size={size}>
          <Path
            d="M0 4C0 1.79086 1.79086 0 4 0H12C14.2091 0 16 1.79086 16 4V12C16 14.2091 14.2091 16 12 16H4C1.79086 16 0 14.2091 0 12V4Z"
            fill="#FF435A"
          />
          <Path
            d="M10.9971 3.698L10.8051 9.494H9.38911L9.18511 3.698H10.9971ZM10.1331 12.302C9.82911 12.302 9.57711 12.21 9.37711 12.026C9.18511 11.834 9.08911 11.598 9.08911 11.318C9.08911 11.038 9.18511 10.806 9.37711 10.622C9.57711 10.43 9.82911 10.334 10.1331 10.334C10.4291 10.334 10.6731 10.43 10.8651 10.622C11.0571 10.806 11.1531 11.038 11.1531 11.318C11.1531 11.598 11.0571 11.834 10.8651 12.026C10.6731 12.21 10.4291 12.302 10.1331 12.302Z"
            fill="white"
          />
          <Path
            d="M6.75492 3.698L6.56292 9.494H5.14692L4.94292 3.698H6.75492ZM5.89092 12.302C5.58692 12.302 5.33492 12.21 5.13492 12.026C4.94292 11.834 4.84692 11.598 4.84692 11.318C4.84692 11.038 4.94292 10.806 5.13492 10.622C5.33492 10.43 5.58692 10.334 5.89092 10.334C6.18692 10.334 6.43092 10.43 6.62292 10.622C6.81492 10.806 6.91092 11.038 6.91092 11.318C6.91092 11.598 6.81492 11.834 6.62292 12.026C6.43092 12.21 6.18692 12.302 5.89092 12.302Z"
            fill="white"
          />
        </PrioIconWrapper>
      );
  }
}

function PrioIconWrapper(
  props: PropsWithChildren<{
    isNegative?: boolean;
    isInactive?: boolean;
    size: "small" | "xsmall";
  }>
) {
  const size = useCircleSize(props.size);
  return (
    <Box
      style={{
        width: size,
        height: size,
        alignItems: "center",
        justifyContent: "center",
      }}
    >
      <Svg width={size} height={size} viewBox="0 0 16 16" fill="none">
        {props.children}
      </Svg>
    </Box>
  );
}
